import { stringify } from "@coverme/querystring";
import Axios from "axios";

export function getPayformLink(encounterId, formData) {
    return Axios.post(`/api/encounters/${encounterId}/payformlink`, formData);
}

export function saveTransactionDetails(encounterId, payload) {
    return Axios.post(`/api/encounters/${encounterId}/paymentTransaction`, payload);
}
